const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    // Unregister any existing service workers to avoid stale cache issues
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
};

export default registerServiceWorker;
